import { InjectionToken } from '@angular/core';
import { PartnerAliasEnum } from '@partners/partner-alias.enum';
import { CustomerType } from '@partners/customer-type.enum';

export const APP_CONFIG = new InjectionToken<AppConfiguration>('Application specific configuration');
export type AppsVersion = {
	'partner-portal': string;
	'azure-vm': string;
	'organization-settings': string;
	'zesty-disk-dashboard': string;
	header: string;
	insights: string;
	'commitment-manager': string;
	kompass: string;
	sidebar: string;
	'ri-manager': string;
};
export interface AppConfiguration {
	headerUrl: string;
	azureVmUrl: string;
	sidebarUrl: string;
	insightsUrl: string;
	commitmentManagerUrl: string;
	kompassUrl: string;
	organizationSettingsUrl: string;
	partnerPortalUrl: string;
	ec2ListingsUrl: string;
	zestyDiskDashboardUrl: string;
	production: boolean;
	installerURL: string;
	azureBucketURL: string;
	apiUrl: string;
	auth: {
		domain: string;
		clientId: string;
		redirectUri: string;
	};
	partner: {
		prefix: PartnerAliasEnum | string;
		name: string;
		id: string;
	};
	featureFlag: {
		LAUNCHDARKLY_SDK_KEY: string;
	};
	hotJar: string;
	mixpanel: string;
	includeComponentsOverview?: boolean;
	customerType: CustomerType;
	appsVersion?: AppsVersion;
}

export const MOCK_APP_CONFIGURATION = {
	apiUrl: '',
	partner: {
		prefix: '',
		name: '',
		id: '',
	},
	featureFlag: {
		LAUNCHDARKLY_SDK_KEY: '',
	},
} as AppConfiguration;
